<template>
  <div class="w1200 dy">
    <div class="bg1" ref="setH">
      <div class="manageBox">
        <div class="searchBox">
          <el-form ref="form" :model="search" label-width="120px" size="small">
            <el-form-item label="年级："
              ><el-select
                v-model="search.gradeId"
                placeholder="选择年级"
                size="small"
                clearable
                @change="getXueKe"
              >
                <el-option
                  v-for="item in conditions.nianjiList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                ></el-option> </el-select
            ></el-form-item>
            <el-form-item label="学科："
              ><el-select
                v-model="search.subjectId"
                placeholder="选择学科"
                size="small"
                clearable
              >
                <el-option
                  v-for="item in conditions.xuekeList"
                  :key="item.node"
                  :label="item.text"
                  :value="item.node"
                ></el-option> </el-select
            ></el-form-item>
            <el-form-item label="纸张类型："
              ><el-select
                v-model="search.paperType"
                placeholder="选择纸张类型"
                size="small"
                clearable
              >
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in conditions.paperTypeList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option> </el-select
            ></el-form-item>
            <el-form-item label="时间筛选："
              ><el-date-picker
                v-model="search.startTime"
                :picker-options="pickerOptionsStart"
                size="small"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 150px"
                placeholder="选择开始日期"
              >
              </el-date-picker>
              <font style="padding: 0 10px">至</font>
              <el-date-picker
                v-model="search.endTime"
                :picker-options="pickerOptionsEnd"
                size="small"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 150px"
                placeholder="选择结束日期"
              >
              </el-date-picker
            ></el-form-item>
            <el-form-item
              ><el-button type="primary" @click="getDataList" size="small"
                >查询</el-button
              >
              <el-button type="primary" @click="daochu" size="small">导出</el-button>
              <el-button @click="clear" size="small">重置</el-button></el-form-item
            ></el-form
          >
        </div>

        <div class="contentBox">
          <div
            style="
              background-color: #edf5ff;
              line-height: 40px;
              float: right;
              padding: 0 15px;
              color: #444;
            "
          >
            合计 | 打印份数<span
              style="color: #0096ff; padding: 0 4px; font-weight: bold"
              >{{ printNumAndPage.printNumber }}</span
            >，打印纸张数<span
              style="color: #0096ff; padding: 0 4px; font-weight: bold"
              >{{ printNumAndPage.filePage }}</span
            >
          </div>
          <el-table stripe :data="tableData" style="width: 100%" border>
            <el-table-column type="index" width="50"></el-table-column>
            <el-table-column prop="schoolName" label="校区"></el-table-column>
            <el-table-column prop="gradeName" label="年级"></el-table-column>
            <el-table-column prop="subjectName" label="学科"></el-table-column>
            <el-table-column prop="paperTypeName" label="纸张类型"></el-table-column>
            <el-table-column
              prop="printNumber"
              sortable="custom"
              label="打印份数"
            ></el-table-column>
            <el-table-column
              prop="filePage"
              sortable="custom"
              label="打印纸张数"
            ></el-table-column>
          </el-table>
          <div class="pages">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="100"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pages.pageAll"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fileDownload from "js-file-download";
import Axios from "axios";
import qs from "qs";
import downLoad from "../mixins/downLoad";

export default {
  name: "printing",
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.search.endTime) {
            return time.getTime() > new Date(this.search.endTime).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.search.startTime) {
            return time.getTime() < new Date(this.search.startTime).getTime() - 86400000;
          }
        },
      },
      search: {
        subjectId: "",
        startTime: "",
        endTime: "",
        page: 1,
        size: 10,
        sectionId: "",
        gradeId: "",
        paperType: "",
      },
      tableData: [],
      pages: {
        pageIndex: 1,
        pageAll: 100,
        pageSize: 10,
      },
      conditions: {
        xueduanList: [],
        nianjiList: [],
        xuekeList: [],
        xuexiaoList: [],
      },
      printNumAndPage: { filePage: 0, printNumber: 0 },
    };
  },
  mixins: [downLoad],
  mounted() {
    this.search.schoolId = JSON.parse(window.sessionStorage.getItem("user")).schoolId;
    this.getNianJi();
    this.getDataList();
    this.getPaperType();
  },
  methods: {
    getPaperType() {
      this.$ajax.post("/common/load/paper/type").then((res) => {
        this.conditions.paperTypeList = res;
        this.search.paperType = "";
      });
    },
    getNianJi() {
      let urlLink = `/common/load/school/grade`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取年级", res);
        this.conditions.nianjiList = res;
      });
    },
    // 获取学科
    getXueKe() {
      if (this.search.gradeId != "") {
        let urlLink = `/common/catalog/load/grade/subject`;
        let param = this.search;
        this.$ajax.post(urlLink, param).then((res) => {
          console.log("获取学科", res);
          this.conditions.xuekeList = res;
        });
      }
    },
    getDataList() {
      let urlLink = `/server/record/print/getStatisticsPrint`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        this.tableData = res.list;
        this.pages.pageAll = res.total;
      });
      this.$ajax.post("/server/record/print/getPrintNumAndPage", param).then((res) => {
        this.printNumAndPage = res ? res : { filePage: 0, printNumber: 0 };
      });
    },
    daochu() {
      let param = this.search;
      var requestUrl = "/server/record/print/exportStatisticsPrint";
      Axios({
        method: "post",
        url: requestUrl,
        data: qs.stringify(param),
        responseType: "blob",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
        },
      })
        .then((res) => {
          fileDownload(res.data, "打印统计.xlsx");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.search.sectionId = "";
      this.search.gradeId = "";
      this.search.subjectId = "";
      this.search.startTime = "";
      this.search.endTime = "";
      this.search.schoolId = "";
      this.search.paperType = "";
    }, // 分页页码变动
    handleSizeChange(v) {
      this.search.size = v;
      this.search.page = 1;
      this.getDataList();
    },
    handleCurrentChange(v) {
      this.search.page = v;
      this.getDataList();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/printStatistics.vue